<!-- 考试详情 -->
<template>
  <div class="examInfo">
    <el-row class="tableHearInputBox" type="flex" justify="space-between">
      <el-col>
        <el-input v-model.trim="query.query" placeholder="请输入姓名" style="width: 200px" @keyup.enter.native="tableLoad"
          @clear="query.query = ''; tableLoad();" clearable suffix-icon="el-icon-search"></el-input>
        <Debounce>
          <el-button style="margin:0px 10px;" size="small" @click="tableLoad">查询</el-button>
        </Debounce>
        <el-select v-model="query.provinceId" filterable @change="proChange" placeholder="请选择">
          <el-option label="全部省份" value=""></el-option>
          <el-option v-for="item in proList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
        <el-select v-model="query.examSiteId" @change="tableLoad" filterable placeholder="请选择">
          <el-option label="全部市代" value=""></el-option>
          <el-option v-for="item in examSitList" :key="item.id" :label="item.name" :value="item.id">
          </el-option>
        </el-select>
        <el-select v-model="query.subjectLevel" @change="tableLoad" filterable placeholder="请选择">
          <el-option label="全部报考等级" value=""></el-option>
          <el-option v-for="item in lvList" :key="item.subjectLevel" :label="item.subjectLevelName"
            :value="item.subjectLevel">
          </el-option>
        </el-select>
      </el-col>
      <!--      <Debounce>-->
      <!--        <el-button type="primary" style="margin-right:10px;" size="small" v-if="$roleFilter('process:whether')" @click="setQualified">生成通过结果</el-button>-->
      <!--      </Debounce>-->
      <Debounce>
        <el-button type="primary" size="small" v-if="$roleFilter('exportAdmissionTicket:offline')"
          @click="importFile">导出准考证</el-button>
      </Debounce>
      <!--      <el-button type="primary" size="small" v-if="$roleFilter('process:ratio')" @click="operatInfo(1)">通过率设置</el-button>-->
    </el-row>
    <el-table :data="tableList" tooltip-effect="dark" border ref="elTable" style="width: 100%;" @sort-change="sortChange"
      @filter-change="filterChange" :header-cell-style="$store.getters.getTableHeadStyle" v-loading="tableIsLoad"
      element-loading-text="加载中" :height="$store.getters.getTableHeight - 50">
      <el-table-column
      type="index"
      width="50"
      label="序号"
      align="center"
      :index="Nindex" 

  > 

    </el-table-column>
      <el-table-column prop="name" label="姓名" align="center"></el-table-column>
      <el-table-column width="80" label="性别" align="center">
        <template slot-scope="scope">
          {{ scope.row.sex === 1 ? "男" : "女" }}
        </template>
      </el-table-column>
      <el-table-column prop="age" label="年龄" width="80" align="center"></el-table-column>
      <el-table-column prop="idNumber" label="证件号码" width="180px" align="center" sortable="custom"></el-table-column>
      <el-table-column prop="provinceName" label="省份" align="center"></el-table-column>
      <el-table-column prop="examSiteName" label="考点" width="100" align="center"></el-table-column>
      <el-table-column prop="registerSiteName" label="报名点" width="100" align="center"></el-table-column>
      <el-table-column label="报考等级" width="80" align="center">
        <template slot-scope="scope">
          {{ scope.row.subjectLevel | getLvTextByLv }}
        </template>
      </el-table-column>
      <el-table-column label="准考证" width="100" align="center">
        <template slot-scope="scope">
          <Debounce v-if="scope.row.examType == 2 || scope.row.planStatus">
            <el-button type="text" style="text-decoration: underline" size="small"
              @click="operatInfo(2, scope.row)">查看准考证</el-button>
          </Debounce>
        </template>
      </el-table-column>
      <template v-if="queryState == 1">
        <el-table-column prop="score" label="成绩分数" align="center" sortable="custom" :min-width="110">
          <template slot-scope="scope">
            <span v-if="queryState == 1">{{ scope.row.score == -1 ? "" : scope.row.score }}</span>
            <span v-else>-</span>
          </template>
        </el-table-column>
      </template>
      <el-table-column  prop="whetherPass" label="成绩等级" align="center" :min-width="110"
        column-key="whetherPass" :filter-multiple="false" filter-placement="bottom-end"
        :filters="[{ text: '合格', value: 1 }, { text: '不合格', value: 2 }, { text: '优秀', value: 3 }]">
        <template slot-scope="{row}">
          <!-- <span v-if="queryState == 1" :style="{ -->
          <span  :style="{
            color: getTextAndColor(row.whetherPass).color
          }">{{ getTextAndColor(row.whetherPass).text }}</span>
          <!-- <span v-else>-</span> -->
        </template>
      </el-table-column>
      <el-table-column prop="" label="考级证书" align="center" v-if="queryState == 1">
        <template slot-scope="scope">
          <div v-if="queryState == 1">
            <!-- <span v-if="(scope.row.fzTime || scope.row.fzTime) && scope.row.score == -1"></span>
            <span style="color:#8AC404"
              v-else-if="scope.row.fzTime == null || scope.row.fzTime == '' || scope.row.score == -1">未生成</span> -->
              <span  style="color:#8AC404" v-if="scope.row.sinFile == null ||scope.row.sinFile == ''"
              >未生成</span
            >
            <span style="color:#409EFF" v-else>已生成</span>
          </div>
          <span v-else>-</span>
        </template>
      </el-table-column>
    </el-table>
    <Pagination :total="query.total" :page.sync="query.pageNum" :limit.sync="query.pageSize" class="pagination-content"        :page-sizes="pageSizes"
      @pagination="tableLoad" />
    <el-dialog custom-class="dailogComponents" :title="visibleType == 1 ? '通过率设置' : '查看视频'" :visible.sync="visible"
      :destroy-on-close="true" :close-on-click-modal="false" v-if="visible" width="800px">
      <div v-show="visibleType == 1" class="dialogBox">
        <el-table :data="passRateList" tooltip-effect="dark" border ref="elTable" style="width: 100%;"
          :header-cell-style="$store.getters.getTableHeadStyle" element-loading-text="加载中" :height="500">
          <el-table-column prop="provinceName" label="省份" align="center"></el-table-column>
          <el-table-column prop="examSiteName" label="考点" align="center"></el-table-column>
          <el-table-column label="报考等级" align="center">
            <template slot-scope="scope">
              {{ scope.row.subjectLevel | getLvTextByLv }}
            </template>
          </el-table-column>
          <el-table-column prop="registerNum" label="考试总人数" align="center" width="140"></el-table-column>
          <el-table-column prop="passNum" label=">=60分人数" align="center" width="140"></el-table-column>
          <el-table-column prop="score" label="平均分" align="center"></el-table-column>
          <el-table-column label="通过率(%)" align="center" width="200">
            <template slot-scope="scope">
              <div>
                <el-input-number class="tableNumInput" style="width:100%" @change="detection($event, scope.row)"
                  v-model="scope.row.ratio" :min="0" :max="100"></el-input-number>
              </div>
            </template>
          </el-table-column>
        </el-table>
        <el-row type="flex" class="dailogButBox" justify="center">
          <el-button size="medium" @click="visible = false">取消</el-button>
          <el-button size="medium" type="primary" @click="submit">确认</el-button>
        </el-row>
      </div>
    </el-dialog>
  </div>
</template>

<script>
export default {
  beforeCreate() {
    if (!this.$route.query.id || !this.$route.query.name) {
      this.$router.go(-1);
      this.$message({ type: "warning", message: "id已过期,请重新查看!", duration: 1000 });
      return;
    }
  },
  mounted() {
    let navList = this.$store.state.websetting.navBreadList;
    navList[2].title = this.$route.query.name + "考试详情";
    this.$store.commit("setNav", navList);
    this.query.examId = this.$route.query.id;
    this.query.notExamNum = this.$route.query.notExamNum;
    this.queryState = this.$route.query.queryState;
    let { userName, roleIdList } = this.$store.getters.getUser;
    // 学校管理员和admin不受影响
    if (userName == 'admin') {
      this.queryState = 1;
    }
    if (roleIdList !== null && (roleIdList.findIndex(item => item == 1) !== -1)) {
      this.queryState = 1;
    }
    this.tableLoad();
    this.getSelectList();
  },
  data() {
    return {
      tableList: [],
      passRateList: [],
      pageSizes: [15, 25, 50, 100, 500, 1000],
      proList: [], //省份考点下拉菜单
      lvList: [{ id: 1, lv: "一级" },
      { id: 2, lv: "二级" },
      { id: 3, lv: "三级" },
      { id: 4, lv: "四级" },
      { id: 5, lv: "五级" },
      { id: 6, lv: "六级" },
      { id: 7, lv: "七级" },
      { id: 8, lv: "八级" },
      { id: 9, lv: "九级" },
      { id: 10, lv: "十级" },
      { id: 11, lv: "初级" },
      { id: 12, lv: "中级" },
      { id: 13, lv: "高级" },], //报考等级下拉
      examSitList: [], //考点下拉菜单
      tableIsLoad: true,
      visible: false,
      exportTicketLoading: false,//导出准考证
      visibleType: 0, //删除
      query: {
        query: "",
        pageNum: 1, // 当前页
        pageSize: 15, // 每页显示条数
        total: 1, //总条数
        examId: "", //考试ID
        examSiteId: "", //考点ID
        provinceId: "", //省份Id
        subjectLevel: "", //报考等级ID
        notExamNum: "", //未考试人数
        orderByField: null, //过滤字段
        orderByMethod: null, //过滤方法
        whetherPass: null, //是否通过
      },
      queryState: 1,
    };
  },
  methods: {
    getTextAndColor(val) {
      let text = ['', '不合格', '合格', '优秀'][val],
        color = ['', '#f56c6c', '#66CC66', '#409eff'][val];
      return {
        text,
        color,
      }
    },
    //检测单行是否验证通过
    detection(val, row) {
      console.log(row)
      this.$axios.post("/process/notice", {
        newRatio: val,
        oldRatio: row.oldVal,
        sumNum: row.registerNum,
      }).then((res) => {
        let data = res.data.data;
        if (data > 0) {
          this.$message.warning(`设置改通过率会有${data}个小于60分考生的考试结果为通过，是否确认？`)
        }
      });
    },
    //列表排序改变事件
    sortChange(column) {
      if (column != null && column.order != null) {
        this.query.orderByMethod = column.order === 'ascending' ? 'asc' : 'desc';
        this.query.orderByField = column.prop === 'idNumber' ? "id_number" : column.prop;
      } else {
        this.query.orderByMethod = null;
        this.query.orderByField = null;
      }
      this.tableLoad();
    },
    //过滤事件
    filterChange(filters) {
      if (filters != null) {
        this.query.whetherPass = filters.whetherPass.length > 0 ? filters.whetherPass[0] : null;
      }
      this.tableLoad();
    },  Nindex(index) {
      // 当前页数 - 1 * 每页数据条数 + 1
      const page = this.query.pageNum // 当前页码
      const pagesize = this.query.pageSize // 每页条数
      return index + 1 + (page - 1) * pagesize
    },

    // 初始化表格
    tableLoad() {
      this.$axios.post("/process/detail", this.query).then((res) => {
        let { list, total } = res.data.data;
        this.tableList = list.map(item => {
          let status = 0;
          if (item.score === -1) {
            status = 0;
          }
          else if (item.score < 60) {
            status = 1;
          }
          else if (item.score > 60 && item.score < 90) {
            status = 2;
          }
          else {
            status = 3;
          }
          item.status = status;
          return item
        });
        this.query.total = total;
        this.tableIsLoad = false;
      });
    },
    // 合格率回显
    getPassRate() {
      let notExamNum = this.query.notExamNum;
      //如果有人未提交视频则出弹框
      if (notExamNum != 0) {
        this.$dailog({
          title: "提示",
          context: "还有" + notExamNum + "个考生未上传视频，最终成绩将做0分处理，是否确定?",
          callbackFun: () => {
            this.$axios.get("/process/ratio/" + this.query.examId).then((res) => {
              let data = res.data.data;
              if (data) {
                this.passRateList = data.map(item => {
                  item.oldVal = item.ratio;
                  return item;
                });
                this.visible = true;
              } else {
                this.passRateList = [];
                this.visible = false;
              }
            });
          },
        });
      } else {
        this.$axios.get("/process/ratio/" + this.query.examId).then((res) => {
          let data = res.data.data;
          if (data) {
            this.passRateList = data.map(item => {
              item.oldVal = item.ratio;
              return item;
            });
            this.visible = true;
          } else {
            this.passRateList = [];
            this.visible = false;
          }
        });
      }

    },
    // 全部下拉菜单
    getSelectList() {
      this.$axios.get("/process/newProvince").then((res) => {
        let data = res.data.data;
        this.proList = data;
      });
      this.$axios.get("/process/examinationSite").then((res) => {
        let data = res.data.data;
        this.examSitList = data;
      });
    },
    operatInfo(type, row) {
      this.visibleType = type;
      if (type === 1) {
        //合格率
        this.getPassRate();
      } else if (type == 2) {
        //查看准考证
        window.open(
          `/api/process/lookNoback/${this.query.examId}/${row.userId}/${row.subjectLevel}`
        );
      }
    },
    submit() {
      if (this.passRateList.length == 0) {
        this.$message({ type: "error", message: "数据为空,无法操作!", duration: 1000 });
        return;
      }
      this.$axios({
        method: "post",
        url: "/process/ratio",
        data: this.passRateList,
      }).then((res) => {
        this.$message({ type: "success", message: "保存成功!", duration: 1000 });
        this.visible = false;
        // this.getPassRate();
      });
    },
    proChange(val) {
      // this.query.examSiteId = "";
      // if (val == "") {
      //   this.examSitList = [];
      // } else {
      //   let proObj = this.proList.find((item) => {
      //     return item.provinceId === val;
      //   });
      //   this.examSitList = proObj.examSiteVOS;
      // }
      this.tableLoad();
    },
    importFile() {
      this.exportTicketLoading = true;
      this.$axios
        .post("/process/export", this.query, { responseType: "blob" })
        .then((res) => {
          this.$exportFile(res);
          this.exportTicketLoading = false;
        });
    },
    setQualified() {
      //查询是合格结果
      this.$axios.get("/process/check/" + this.query.examId).then((res) => {
        if (res.data.data) {
          this.$dailog({
            title: "提示",
            context: "已有通过结果, 重新生成则覆盖, 是否重新生成?",
            callbackFun: () => {
              this.$axios.get("/process/generate/" + this.query.examId).then((res) => {
                let { code, msg } = res.data
                this.$message({ type: code == 10000 ? "success" : 'error', message: code == 10000 ? "已生成!" : msg, duration: 1000 });
                this.tableLoad();
              });
            },
          });
        } else {
          this.$axios.get("/process/generate/" + this.query.examId).then((res) => {
            let { code, msg } = res.data
            this.$message({ type: code == 10000 ? "success" : 'error', message: code == 10000 ? "已生成!" : msg, duration: 1000 });
            this.tableLoad();
          });
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.tableHearInputBox {
  .el-select {
    width: 200px;
    margin-right: 10px;
  }
}
</style>
<style lang="scss">
.examInfo {
  .tableNumInput {
    padding-left: 0px !important;
    padding-right: 0px !important;

    .el-input {
      padding-left: 0px !important;
      padding-right: 0px !important;
    }
  }

  .video-player-button {
    cursor: pointer;
    margin-right: 10px;
  }

  .video-player {
    padding: 0px 20px;
    width: calc(100% - 40px);

    .video-js {
      width: 100%;
      overflow: hidden;
      height: 700px;
    }
  }

  .videos-rotate1 {
    .vjs-tech {
      transform: rotateZ(-90deg);
    }
  }

  .videos-rotate2 {
    .vjs-tech {
      transform: rotateZ(-180deg);
    }
  }

  .videos-rotate3 {
    .vjs-tech {
      transform: rotateZ(-270deg);
    }
  }
}
</style>
